import { lazy, Suspense, type ComponentType, type ReactNode } from 'react'
import LoadingSpinner from '@/components/common/LoadingSpinner'

export function lazyPage(
  importFn: () => Promise<{ default: ComponentType }>,
  fallback: ReactNode = <LoadingSpinner />,
) {
  const LazyComponent = lazy(importFn)
  return function LazyPageWrapper() {
    return (
      <Suspense fallback={fallback}>
        <LazyComponent />
      </Suspense>
    )
  }
}
